import { Icon, IconsEnum } from 'components/Icons';
import { useTranslation } from 'hooks/useLingUI';
import { Controller, FieldValues, Path, UseControllerProps } from 'react-hook-form';
import { ItemWithTranslation } from 'types/swagger';
import { isControlledInput } from '../utils';
import styles from './ChipCheckBox.module.scss';

export type ChipCheckBoxProps = ItemWithTranslation<{ label?: string }> & {
  value: string;
  checked?: boolean;
  handleFilterChange?: Function;
  hasMarginTop?: boolean;
  hasMarginRight?: boolean;
  hasMarginBottom?: boolean;
  hasMarginLeft?: boolean;
  containerClassName?: string;
};

export type ControlledChipCheckBoxProps<
  T extends FieldValues = FieldValues,
  K extends Path<T> = Path<T>
> = ChipCheckBoxProps & UseControllerProps<T, K>;

export function ChipCheckBox<T extends FieldValues = FieldValues>(props: ControlledChipCheckBoxProps<T>): JSX.Element;

export function ChipCheckBox(props: ChipCheckBoxProps): JSX.Element;

export function ChipCheckBox(props: ChipCheckBoxProps | ControlledChipCheckBoxProps): JSX.Element {
  const { t } = useTranslation();
  const { checked, handleFilterChange, value, label, labelTrKey, containerClassName } = props;

  const text = label ? t(labelTrKey, label) : value;

  if (isControlledInput<ControlledChipCheckBoxProps>(props)) {
    return (
      <Controller
        control={props.control}
        name={props.name}
        rules={props.rules}
        defaultValue={props.defaultValue}
        render={({ field: { name, ref, value: formValue, onBlur, onChange } }) => (
          <div
            className={`${styles.chip} ${checked ? styles.checked : ''} ${
              props.hasMarginTop ? styles.containerMarginTop : ''
            } ${props.hasMarginRight ? styles.containerMarginRight : ''} ${
              props.hasMarginBottom ? styles.containerMarginBottom : ''
            } ${props.hasMarginLeft ? styles.containerMarginLeft : ''} 
            ${containerClassName && containerClassName}`}
          >
            {JSON.stringify(props.hasMarginTop)}
            <label htmlFor={value} className={styles.label}>
              {text}
              <input
                id={value}
                name={name}
                type="checkbox"
                value={formValue}
                checked={checked || false}
                className={styles.checkbox}
                onChange={(e) => {
                  onChange(e);
                  handleFilterChange && handleFilterChange(e.target);
                }}
                onBlur={() => {
                  onBlur();
                }}
              />
            </label>
            {checked && <Icon iconId={IconsEnum.CLOSE} className={styles.icon} color="var(--color-surface-01)" />}
          </div>
        )}
      />
    );
  }
  return (
    <div className={`${styles.chip} ${checked ? styles.checked : ''} ${containerClassName && containerClassName}`}>
      <label htmlFor={value} className={styles.label}>
        {text}
        <input
          id={value}
          name={value}
          type="checkbox"
          value={value}
          checked={checked}
          className={styles.checkbox}
          onChange={(e) => {
            handleFilterChange && handleFilterChange(e.target);
          }}
        />
      </label>
      {checked && <Icon iconId={IconsEnum.CLOSE} className={styles.icon} color="var(--color-surface-01)" />}
    </div>
  );
}
